import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "ggdy-bts"
};
const _hoisted_2 = {
  class: "l-button"
};
const _hoisted_3 = {
  class: "l-button"
};
const _hoisted_4 = {
  key: 0,
  class: "l-button"
};
const _hoisted_5 = {
  key: 1,
  class: "ggdy-bts"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "dialog-footer"
};
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_vxe_toolbar = _resolveComponent("vxe-toolbar");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_vxe_button = _resolveComponent("vxe-button");
  const _component_vxe_option = _resolveComponent("vxe-option");
  const _component_vxe_select = _resolveComponent("vxe-select");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_toolbar, null, {
    buttons: _withCtx(() => [_ctx.ggdybts == 'all' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.checkhide && _ctx.checkhide(...args)),
      class: "l-button"
    }, "选择显示字段"), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_upload, {
      action: "",
      "auto-upload": false,
      multiple: false,
      "show-file-list": false,
      "on-change": _ctx.exportSkU,
      "file-list": _ctx.data.fileList
    }, {
      default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" 导入SKU ")])),
      _: 1,
      __: [14]
    }, 8, ["on-change", "file-list"])]), _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.debounceMethods(_ctx.deriveSKU, 1)),
      class: "l-button"
    }, "导出SKU"), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_upload, {
      action: "",
      "auto-upload": false,
      multiple: false,
      "show-file-list": false,
      "on-change": _ctx.deriveJG,
      "file-list": _ctx.data.fileList
    }, {
      default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode(" 导入结构BOM表 ")])),
      _: 1,
      __: [15]
    }, 8, ["on-change", "file-list"])]), _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = $event => _ctx.debounceMethods(_ctx.deriveSKU, 3)),
      class: "l-button"
    }, "导出结构BOM表"), _ctx.nobts.indexOf('bzbom') !== -1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_upload, {
      action: "",
      "auto-upload": false,
      multiple: false,
      "show-file-list": false,
      "on-change": _ctx.deriveBZ,
      "file-list": _ctx.data.fileList
    }, {
      default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode(" 导入包装BOM表 ")])),
      _: 1,
      __: [16]
    }, 8, ["on-change", "file-list"])])) : _createCommentVNode("", true), _ctx.nobts.indexOf('bzbom') !== -1 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: _cache[3] || (_cache[3] = $event => _ctx.debounceMethods(_ctx.deriveSKU, 4)),
      class: "l-button"
    }, "导出包装BOM表")) : _createCommentVNode("", true), _ctx.pageTag == 'ggdy' ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "l-button",
      onClick: _cache[4] || (_cache[4] = (...args) => _ctx.skucheck && _ctx.skucheck(...args))
    }, "sku检测")) : _createCommentVNode("", true), _ctx.pageTag == 'xxlr' ? (_openBlock(), _createElementBlock("div", {
      key: 3,
      class: "l-button",
      onClick: _cache[5] || (_cache[5] = (...args) => _ctx.syncPRlist && _ctx.syncPRlist(...args))
    }, "同步到产品目录")) : _createCommentVNode("", true), _ctx.pageTag == 'xxlr' ? (_openBlock(), _createElementBlock("div", {
      key: 4,
      class: "l-button",
      onClick: _cache[6] || (_cache[6] = (...args) => _ctx.syncTCOsys && _ctx.syncTCOsys(...args))
    }, "同步到成本系统")) : _createCommentVNode("", true), _ctx.nobts.indexOf('add') == -1 ? (_openBlock(), _createElementBlock("div", {
      key: 5,
      onClick: _cache[7] || (_cache[7] = (...args) => _ctx.additem && _ctx.additem(...args)),
      class: "l-button"
    }, "新增行")) : _createCommentVNode("", true), _ctx.nobts.indexOf('delet') == -1 ? (_openBlock(), _createElementBlock("div", {
      key: 6,
      onClick: _cache[8] || (_cache[8] = (...args) => _ctx.deletitem && _ctx.deletitem(...args)),
      class: "l-button"
    }, "删除行")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_ctx.ggdybts !== "add" ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _cache[9] || (_cache[9] = (...args) => _ctx.checkhide && _ctx.checkhide(...args)),
      class: "l-button"
    }, "选择显示字段")) : _createCommentVNode("", true)]))]),
    _: 1
  }), _createVNode(_component_vxe_table, {
    ref: "xTable1",
    loading: _ctx.data.ggdyloading,
    data: _ctx.data.ggdyTableData,
    class: "ggdycss",
    "max-height": "400",
    "edit-config": {
      trigger: 'click',
      mode: 'cell',
      showStatus: true
    },
    onCheckboxChange: _ctx.selectionChange,
    "keep-source": "",
    onCheckboxAll: _ctx.selectAllChange,
    onClick: _ctx.touchTable,
    border: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.zdkeylist, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: item.key
      }, [item.value && item.key == 'indxs' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 0,
        type: "checkbox",
        width: "50",
        align: "center"
      })) : _createCommentVNode("", true), item.value && item.key == 'seq' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 1,
        type: "seq",
        title: "序号",
        width: "50",
        align: "center"
      })) : _createCommentVNode("", true), item.value && item.key == 'brand' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 2,
        field: "brand",
        title: "品牌",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "140",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.brand,
          "onUpdate:modelValue": $event => row.brand = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'brand')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'name' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 3,
        field: "name",
        title: "产品名称",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "140",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.name,
          "onUpdate:modelValue": $event => row.name = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'name')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'image' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 4,
        field: "image",
        title: "产品图片",
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createVNode(_component_el_upload, {
          ref_for: true,
          ref: "uploadRef",
          action: _ctx.data.upLoadUrl,
          "with-credentials": true,
          "on-success": function (res, file, file_list) {
            return _ctx.handleSuccess(res, file, file_list, row, row.indextb);
          },
          "show-file-list": false,
          name: "file",
          limit: 1,
          accept: ".png, .jpg"
        }, {
          default: _withCtx(() => [row.image ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            src: row.image,
            class: "avatar"
          }, {
            error: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("div", {
              class: "image-slot"
            }, [_createElementVNode("i", {
              class: "el-icon-picture-outline"
            })], -1)])),
            _: 2
          }, 1032, ["src"])) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "el-icon-plus"
          }))]),
          _: 2
        }, 1032, ["action", "on-success"]), _ctx.data.enlargeImg ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "img-show position-f",
          style: _normalizeStyle(_ctx.data.top)
        }, [_createElementVNode("img", {
          src: _ctx.data.enlargeImg
        }, null, 8, _hoisted_6)], 4)), [[_vShow, row.enlargeImgShow]]) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'spu' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 5,
        field: "spu",
        title: "产品SPU",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "250",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.spu,
          "onUpdate:modelValue": $event => row.spu = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'spu')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'sku' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 6,
        field: "sku",
        title: "产品规格型号(SKU)",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "260",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.sku,
          "onUpdate:modelValue": $event => row.sku = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'sku')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'params' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 7,
        field: "params",
        title: "规格参数",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "260",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.params,
          "onUpdate:modelValue": $event => row.params = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'params')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'jgbom' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 8,
        title: "结构BOM清单",
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row,
          checked
        }) => [_createVNode(_component_vxe_button, {
          type: "text",
          status: "primary",
          content: "查看",
          onClick: $event => _ctx.getRoutebomInfo(row, 'jgbom')
        }, null, 8, ["onClick"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'bzbom' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 9,
        title: "包装BOM清单",
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row,
          checked
        }) => [_createVNode(_component_vxe_button, {
          type: "text",
          status: "primary",
          content: "查看",
          onClick: $event => _ctx.getRoutebomInfo(row, 'bzbom')
        }, null, 8, ["onClick"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'material' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 10,
        field: "material",
        title: "产品材质",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.material,
          "onUpdate:modelValue": $event => row.material = $event,
          modelModifiers: {
            trim: true,
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'material')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'protocol' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 11,
        field: "protocol",
        title: "协议",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "180",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.protocol,
          "onUpdate:modelValue": $event => row.protocol = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'protocol')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 12,
        field: "rate",
        title: "速率",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.rate,
          "onUpdate:modelValue": $event => row.rate = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'rate')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'package' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 13,
        field: "package",
        title: "包装",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.package), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_select, {
          modelValue: row.package,
          "onUpdate:modelValue": $event => row.package = $event,
          transfer: true,
          onChange: $event => _ctx.textinput($event, row.indextb, 'package')
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.paklist, it => {
            return _openBlock(), _createBlock(_component_vxe_option, {
              key: it.key,
              value: it.value,
              label: it.value
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'safe' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 14,
        field: "safe",
        title: "安规",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.safe), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_select, {
          modelValue: row.safe,
          "onUpdate:modelValue": $event => row.safe = $event,
          transfer: true,
          onChange: $event => _ctx.textinput($event, row.indextb, 'safe')
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.aglist, it => {
            return _openBlock(), _createBlock(_component_vxe_option, {
              key: it.key,
              value: it.value,
              label: it.value
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'interface' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 15,
        field: "interface",
        title: "接口(输入)",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.interface,
          "onUpdate:modelValue": $event => row.interface = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'interface')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'other' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 16,
        field: "other",
        title: "尺码/数量/长度",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.other,
          "onUpdate:modelValue": $event => row.other = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'other')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'color' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 17,
        field: "color",
        title: "产品颜色",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.color), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_select, {
          modelValue: row.color,
          "onUpdate:modelValue": $event => row.color = $event,
          transfer: true,
          onChange: $event => _ctx.textinput($event, row.indextb, 'color')
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.colorlist, it => {
            return _openBlock(), _createBlock(_component_vxe_option, {
              key: it.key,
              value: it.value,
              label: it.value
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'version' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 18,
        field: "version",
        title: "功能/版本",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.version,
          "onUpdate:modelValue": $event => row.version = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'version')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'output' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 19,
        field: "output",
        title: "输出接口",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "170",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.output,
          "onUpdate:modelValue": $event => row.output = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'output')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'code69' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 20,
        field: "code69",
        title: "69码",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "170",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.code69,
          "onUpdate:modelValue": $event => row.code69 = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'code69')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'material_num' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 21,
        field: "material_num",
        title: "备料数量",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "left"
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.material_num,
          "onUpdate:modelValue": $event => row.material_num = $event,
          type: "integer",
          min: "0",
          max: "99999999",
          onBlur: $event => _ctx.textinput($event, row.indextb, 'material_num')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'order_num' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 22,
        field: "order_num",
        title: "首批订单数量",
        width: "120",
        align: "left "
      }, {
        default: _withCtx(({
          row
        }) => [_ctx.pageTag == 'spxdmx' && row.order_num ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: $event => _ctx.openXDmx(row.id, row.sku),
          style: {
            "color": "#409EFF",
            "cursor": "pointer"
          }
        }, _toDisplayString(row.order_num ? row.order_num : 0), 9, _hoisted_7)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row.order_num ? row.order_num : 0), 1))]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'mould_fare_sj' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 23,
        field: "mould_fare_sj",
        title: "模具费(塑胶)",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.mould_fare_sj ? row.mould_fare_sj : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.mould_fare_sj,
          "onUpdate:modelValue": $event => row.mould_fare_sj = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'mould_fare_sj', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'mould_fare_wj' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 24,
        field: "mould_fare_wj",
        title: "模具费(五金)",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.mould_fare_wj ? row.mould_fare_wj : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.mould_fare_wj,
          "onUpdate:modelValue": $event => row.mould_fare_wj = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'mould_fare_wj', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'electron_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 25,
        field: "electron_fare",
        title: "电子",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.electron_fare ? row.electron_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.electron_fare,
          "onUpdate:modelValue": $event => row.electron_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'electron_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'structure_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 26,
        field: "structure_fare",
        title: "结构/本体",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.structure_fare ? row.structure_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.structure_fare,
          "onUpdate:modelValue": $event => row.structure_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'structure_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'power_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 27,
        field: "power_fare",
        title: "电源",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.power_fare ? row.power_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.power_fare,
          "onUpdate:modelValue": $event => row.power_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'power_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'line_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 28,
        field: "line_fare",
        title: "线材",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.line_fare ? row.line_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.line_fare,
          "onUpdate:modelValue": $event => row.line_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'line_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'package_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 29,
        field: "package_fare",
        title: "包材",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.package_fare ? row.package_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.package_fare,
          "onUpdate:modelValue": $event => row.package_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'package_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'parts_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 30,
        field: "parts_fare",
        title: "辅料/配件",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.parts_fare ? row.parts_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.parts_fare,
          "onUpdate:modelValue": $event => row.parts_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'parts_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'other_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 31,
        field: "other_fare",
        title: "硬盘/运费/其他/DDR",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.other_fare ? row.other_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.other_fare,
          "onUpdate:modelValue": $event => row.other_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'other_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'process_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 32,
        field: "process_fare",
        title: "加工费用",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.process_fare ? row.process_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.process_fare,
          "onUpdate:modelValue": $event => row.process_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'process_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'auth_test_fare' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 33,
        field: "auth_test_fare",
        title: "认证/测试费用",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.auth_test_fare ? row.auth_test_fare : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.auth_test_fare,
          "onUpdate:modelValue": $event => row.auth_test_fare = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'auth_test_fare', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'total_cost' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 34,
        field: "total_cost",
        title: "总成本(未摊模具)",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "200",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.total_cost ? row.total_cost : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.total_cost,
          "onUpdate:modelValue": $event => row.total_cost = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'total_cost', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'mould_cost' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 35,
        field: "mould_cost",
        title: "出厂价(TCO成本)",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.mould_cost ? row.mould_cost : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.mould_cost,
          "onUpdate:modelValue": $event => row.mould_cost = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'mould_cost', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'tco_cost' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 36,
        field: "tco_cost",
        title: "物料成本价",
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(_ctx.setNums83(parseFloat(row.structure_fare ? row.structure_fare : 0) + parseFloat(row.power_fare ? row.power_fare : 0) + parseFloat(row.line_fare ? row.line_fare : 0) + parseFloat(row.parts_fare ? row.parts_fare : 0) + parseFloat(row.other_fare ? row.other_fare : 0) + parseFloat(row.process_fare ? row.process_fare : 0) + parseFloat(row.package_fare ? row.package_fare : 0) + parseFloat(row.electron_fare ? row.electron_fare : 0) || 0, 8, 4, row.indextb, 'tco_cost')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'tco_rate' && _ctx.data.userInfo.isall == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 37,
        title: "TCO毛利率",
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.setNums83((parseFloat(row.mould_cost ? row.mould_cost : 0) - (parseFloat(row.structure_fare ? row.structure_fare : 0) + parseFloat(row.power_fare ? row.power_fare : 0) + parseFloat(row.line_fare ? row.line_fare : 0) + parseFloat(row.parts_fare ? row.parts_fare : 0) + parseFloat(row.other_fare ? row.other_fare : 0) + parseFloat(row.process_fare ? row.process_fare : 0) + parseFloat(row.package_fare ? row.package_fare : 0) + parseFloat(row.electron_fare ? row.electron_fare : 0))) / parseFloat(row.mould_cost ? row.mould_cost : 0) * 100 || 0, 8, 4, row.indextb, 'tco_rate')) + "%", 1)]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'agent_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 38,
        field: "agent_price",
        title: "代理商价",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.agent_price ? row.agent_price : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.agent_price,
          "onUpdate:modelValue": $event => row.agent_price = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'agent_price', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'channel_rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 39,
        field: "channel_rate",
        title: "渠道毛利润率",
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [!row.agent_price || parseFloat(row.agent_price) == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "0%")) : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.setNums83(((parseFloat(row.agent_price) ? parseFloat(row.agent_price) : 0) - parseFloat(row.mould_cost ? row.mould_cost : 0)) / (parseFloat(row.agent_price) ? parseFloat(row.agent_price) : 0) * 100 || 0, 8, 4, row.indextb, 'channel_rate')) + " %", 1))]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'distribution_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 40,
        field: "distribution_price",
        title: "经销价",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.distribution_price ? row.distribution_price : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.distribution_price,
          "onUpdate:modelValue": $event => row.distribution_price = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'distribution_price', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'distribution_rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 41,
        title: "经销商毛利率",
        width: "120",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.setNums83((parseFloat(row.min_retail_price ? row.min_retail_price : 0) - parseFloat(row.distribution_price ? row.distribution_price : 0)) / parseFloat(row.min_retail_price ? row.min_retail_price : 0) * 100, 8, 4, row.indextb, 'distribution_rate')) + "%", 1)]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'retail_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 42,
        field: "retail_price",
        title: "建议零售价",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.retail_price ? row.retail_price : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.retail_price,
          "onUpdate:modelValue": $event => row.retail_price = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'retail_price', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'min_retail_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 43,
        field: "min_retail_price",
        title: "最低零售价",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, "¥" + _toDisplayString(row.min_retail_price ? row.min_retail_price : '0.000'), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.min_retail_price,
          "onUpdate:modelValue": $event => row.min_retail_price = $event,
          type: "number",
          min: "0",
          onBlur: $event => _ctx.checkNum($event, row.indextb, 'min_retail_price', 8, 4)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })) : _createCommentVNode("", true), item.value && item.key == 'b2c_rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 44,
        field: "b2c_rate",
        title: "B2C毛利润率",
        width: "130",
        align: "center"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.setNums83((parseFloat(row.min_retail_price ? row.min_retail_price : 0) - parseFloat(row.mould_cost ? row.mould_cost : 0)) / parseFloat(row.min_retail_price ? row.min_retail_price : 0) * 100 || 0, 8, 4, row.indextb, 'b2c_rate')) + "%", 1)]),
        _: 1
      })) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  }, 8, ["loading", "data", "onCheckboxChange", "onCheckboxAll", "onClick"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.data.isShowColTable,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.data.isShowColTable = $event),
    "close-on-click-modal": false,
    "destroy-on-close": "",
    "append-to-body": false,
    width: "20%",
    title: "字段选择弹窗",
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_11, [_createElementVNode("div", {
      class: "l-button",
      onClick: _cache[10] || (_cache[10] = (...args) => _ctx.setFields && _ctx.setFields(...args)),
      style: {
        "float": "right"
      }
    }, "确 定")])]),
    default: _withCtx(() => [_createVNode(_component_el_table, {
      ref: "multipleTable",
      border: "",
      data: _ctx.data.keytableData,
      onSelectionChange: _ctx.handleSelectionChange_zd,
      "header-row-class-name": "zdhead",
      "cell-class-name": "zdcell",
      "max-height": 350,
      class: "zdtable",
      "row-class-name": _ctx.tableRowClassName
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        type: "selection",
        width: "55",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "name",
        label: "字段名称",
        align: "center"
      })]),
      _: 1
    }, 8, ["data", "onSelectionChange", "row-class-name"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    title: "提示",
    modelValue: _ctx.data.errorPromptShow,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _ctx.data.errorPromptShow = $event),
    width: "30%",
    "before-close": _ctx.handleClose
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_13, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[12] || (_cache[12] = $event => _ctx.data.errorPromptShow = false)
    }, {
      default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("确 定")])),
      _: 1,
      __: [18]
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      style: {
        "max-height": "500px",
        "overflow-y": "auto"
      },
      innerHTML: _ctx.data.errorMsg
    }, null, 8, _hoisted_12)]),
    _: 1
  }, 8, ["modelValue", "before-close"])]);
}